import { useLocation, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useStore } from 'effector-react';
import { Theme } from '@consta/uikit/Theme';
import { presetLilianiDefault } from './presets/presetLilianiDefault';
import {
  BrowserRouter,
  Route,
  Routes,
  ProtectedRoutes,
  AppRoot,
} from '@lib/routing-engine';
import {
  $isAuthorized,
  $isAuthorizing,
  $isSubscribed,
  $userData,
  $userPermissions,
  logout,
} from '@@/auth/store/auth.store';
import { useGlobalEffects } from '@@/app/hooks/use-global-effects.hook';
import { SideNav } from '@ui/side-nav';
import { AppTemplate } from '@ui/templates';
import { StoragePage } from '@pages/storage';

import { HomePage } from '@@/home/pages/home';
import { MixingPage } from '@@/mixing/pages/mixing';
import { PricesPage } from '@pages/prices';
import { ConservationPage } from '@@/conservation/pages/conservation';
import { CreateWarehousePage } from '@pages/create-warehouse';

import { Authorizing } from '@@/auth/components/authorizing';
import { NotFoundPage } from '@@/app/pages/404';
import { APP_SECTIONS } from '@@/common/constants/app-sections.constant';
import { closeContextMenu } from '@widgets/storage-viewer/model';

import { DiContainer } from '@@/di/di-container';
import { AuthService } from '@@/auth/services/auth.service';
import { LoggerService } from '@@/common/services/logger.service';

import '@lib/ymaps-arrow';

// TODO: перенести стили в модуль
import './assets/app.css';
import { RecipeDetailsPage } from '@/modules/mixing/pages/recipe-details';
import { ManualMixingPage } from '@/modules/mixing/pages/manual-mixing';
import { ConfigProvider } from 'antd';
import { InDeveloping } from '@/modules/common/components/in-developing';
import { SellerAccountPage } from '@/modules/seller-account/pages';
import { CalculatorPage } from '@/modules/mixing/pages/calculator';
import { LogisiticsPage } from '@/modules/mixing/pages/logistics';
import { OfferPage } from '@/modules/offer/pages/offer';
import { RecipesPageNew } from '@/modules/mixing/pages/recipes-new';
import { DevModeIndicator } from '@/modules/common/components/dev-mode-indicator';
import { NotifierModal } from '@/modules/common/components/notifer-modal';
import { RegisterPage } from '@/modules/home/pages/register';
import { BuyerAccountPage } from '@/modules/buyer-account/pages/main/index.page';
import { PointsPage } from '@/modules/buyer-account/pages/points';
import { BuyerSettingsPage } from '@/modules/buyer-account/pages/settings/index.page';
import { CrossMixingPage } from '@/modules/mixing/pages/cross-mixing';
import { ActivesModal } from '@/modules/mixing/components/actives-modal';
import {
  $activesModalOpen,
  setActivesModalOpen,
} from '@/modules/mixing/store/analytical-mixing.store';
import { NoAuthorizedPage } from '@/modules/auth/pages/no-authorized';
import { MixerPage } from '@/modules/mixing/pages/mixer';
import { ManagementLogisticsPage } from '@/modules/logistics/pages/management';
import { HomeNewPage } from '@/modules/home/pages/home-new';
import { OfferAdvancedPage } from '@/modules/offer/pages/offer-advanced';
import { OfferContractsPage } from '@/modules/offer/pages/offer-contracts';
import { ContractDetailsPage } from '@/modules/offer/pages/contract-details/index.component';
import { SearchPage } from '@/modules/search/pages/search';
import { ANTD_THEME_GLOBAL_TOKEN } from '@/modules/common/constants/antd-theme-global-token.constant';
import { Loader } from '@consta/uikit/Loader';
import { BestPricesPage } from '@/modules/best-prices/pages/best-prices';
import { ForbiddenPage } from '@/modules/app/pages/403';
import { RecalculateIndicatorModal } from '@/widgets/recalculate-indicator/components';

const authService = DiContainer.get(AuthService);
const loggerService = DiContainer.get(LoggerService);
if (!PUBLIC_IS_SERVER)
  loggerService.init({
    environment: PUBLIC_MODE,
    dsn: PUBLIC_SENTRY_DSN,
  });

export function App() {
  const userData = useStore($userData);
  const isAuthorized = useStore($isAuthorized);
  //const isSubscribed = useStore($isSubscribed);
  const isAuthorizing = useStore($isAuthorizing);
  const permissions = useStore($userPermissions);
  //const activesModalOpen = useStore($activesModalOpen);
  const [tooltipData, setTooltipData] = useState({
    top: 0,
    left: 0,
    display: false,
    price_all: '0',
    delivery_price: '0',
    net_price: '0',
  });
  useGlobalEffects();
  // TODO: реализовать механизм glob импорт роутов из модулей

  return (
    <ConfigProvider theme={ANTD_THEME_GLOBAL_TOKEN}>
      <Theme preset={presetLilianiDefault} onAuxClick={() => closeContextMenu()}>
        <Authorizing className="app__authorizing" loading={isAuthorizing} />

        {PUBLIC_MODE === 'development' && <DevModeIndicator />}
        <NotifierModal
          label={
            <>
              Для получения полноценного доступа к сервису SBT, обратитесь, пожалуйста в{' '}
              <br />
              Отдел продаж, по номеру телефона: <br /> <b>8 (800) 555-99-83</b>
            </>
          }
        />

        <RecalculateIndicatorModal />

        {/* <Suspense fallback={<Loader className='lazyLoader' />}> */}
        <BrowserRouter>
          {/* {activesModalOpen && (
            <>
              <ActivesModal
                visible={activesModalOpen}
                onClose={() => setActivesModalOpen({ payload: false })}
                tooltipData={tooltipData}
                setTooltipData={setTooltipData}
              />
            </>
          )} */}
          <Routes>
            <Route element={<AppRoot />}>
              <Route
                path="/"
                element={userData?.buyer ? <BuyerAccountPage /> : <HomeNewPage />}
              />
              <Route path="/signup" element={<RegisterPage />} />

              {userData?.buyer ? (
                <Route element={<ProtectedRoutes />}>
                  {/* <Route path="/buyer-account" element={<BuyerAccountPage />} /> */}
                  <Route path="/buyer-points" element={<PointsPage />} />
                  <Route path="/buyer-settings" element={<BuyerSettingsPage />} />
                </Route>
              ) : (
                <Route element={<ProtectedRoutes />}>
                  <Route path="/" element={<AppTemplateWithNavigationIfNeeded />}>
                    <>
                      {/* Storage */}
                      <>
                        <Route path="/storage" element={<StoragePage />} />

                        {permissions.storage ? (
                          <Route
                            path="/storage/create-warehouse"
                            element={<CreateWarehousePage />}
                          />
                        ) : (
                          <Route
                            path="/storage/create-warehouse"
                            element={<ForbiddenPage />}
                          />
                        )}
                      </>
                      <Route
                        path="/storage/create-warehouse/fixed"
                        element={<CreateWarehousePage />}
                      />
                    </>

                    {/* Mix */}
                    <>
                      {permissions.mix ? (
                        <Route
                          path="/best-prices"
                          element={
                            <BestPricesPage
                              tooltipData={tooltipData}
                              setTooltipData={setTooltipData}
                            />
                          }
                        />
                      ) : (
                        <Route path="/best-prices" element={<ForbiddenPage />} />
                      )}
                      {permissions.mix ? (
                        <Route path="/mixing" element={<MixingPage />} />
                      ) : (
                        <Route path="/mixing" element={<ForbiddenPage />} />
                      )}
                      {permissions.mix ? (
                        <Route
                          path="/mixing/logistics/management"
                          element={<ManagementLogisticsPage />}
                        />
                      ) : (
                        <Route
                          path="/mixing/logistics/management"
                          element={<ForbiddenPage />}
                        />
                      )}

                      {permissions.mix ? (
                        <Route
                          path="/mixing/recipe/detail/:id"
                          element={<RecipeDetailsPage />}
                        />
                      ) : (
                        <Route
                          path="/mixing/recipe/detail/:id"
                          element={<ForbiddenPage />}
                        />
                      )}
                      {permissions.mix ? (
                        <Route path="/mixing/mixer/:id" element={<MixerPage />} />
                      ) : (
                        <Route path="/mixing/mixer/:id" element={<ForbiddenPage />} />
                      )}
                      {permissions.mix ? (
                        <Route path="/mixing/cross" element={<CrossMixingPage />} />
                      ) : (
                        <Route path="/mixing/cross" element={<ForbiddenPage />} />
                      )}
                      {permissions.mix ? (
                        <Route path="/mixing/manual" element={<ManualMixingPage />} />
                      ) : (
                        <Route path="/mixing/manual" element={<ForbiddenPage />} />
                      )}
                    </>

                    {/* Calculator */}
                    <>
                      {permissions.calculator ? (
                        <Route path="/calculator" element={<CalculatorPage />} />
                      ) : (
                        <Route path="/calculator" element={<ForbiddenPage />} />
                      )}
                    </>
                    {/* Transactions */}
                    <>
                      {permissions.transactions ? (
                        <Route
                          path="/mixing/recipes-new"
                          element={<RecipesPageNew />}
                        />
                      ) : (
                        <Route path="/mixing/recipes-new" element={<ForbiddenPage />} />
                      )}
                      {permissions.transactions ? (
                        <Route path="/offer" element={<OfferAdvancedPage />} />
                      ) : (
                        <Route path="/offer" element={<ForbiddenPage />} />
                      )}
                      {permissions.transactions ? (
                        <Route
                          path="/offer/contracts"
                          element={<OfferContractsPage />}
                        />
                      ) : (
                        <Route path="/offer/contracts" element={<ForbiddenPage />} />
                      )}
                      {permissions.transactions ? (
                        <Route
                          path="/offer/contracts/:id"
                          element={<ContractDetailsPage />}
                        />
                      ) : (
                        <Route
                          path="/offer/contracts/:id"
                          element={<ForbiddenPage />}
                        />
                      )}
                    </>

                    {/* <Route path="/mixing-simple" element={<SimpleMixingPage />} /> */}
                    {/* Profile */}

                    <>
                      {permissions.profile ? (
                        <Route path="/account/seller" element={<SellerAccountPage />} />
                      ) : (
                        <Route path="/account/seller" element={<ForbiddenPage />} />
                      )}
                      {permissions.profile ? (
                        <Route path="/mixing/logistics" element={<LogisiticsPage />} />
                      ) : (
                        <Route path="/mixing/logistics" element={<ForbiddenPage />} />
                      )}
                    </>

                    {/* Search */}
                    <>
                      {permissions.search ? (
                        <Route path="/search" element={<SearchPage />} />
                      ) : (
                        <Route path="/search" element={<ForbiddenPage />} />
                      )}
                    </>

                    <>
                      <Route path="/prices" element={<PricesPage />} />
                      <Route path="/conservation" element={<ConservationPage />} />
                    </>
                  </Route>
                </Route>
              )}

              <Route path="/development" element={<InDeveloping />} />
              <Route
                path="*"
                element={!isAuthorized ? <NoAuthorizedPage /> : <NotFoundPage />}
              />
            </Route>
          </Routes>
        </BrowserRouter>
        {/* </Suspense> */}
      </Theme>
    </ConfigProvider>
  );
}

/**
 * Этот компонент был создан только чтобы быстро реализовать возможность использовать страницы без SideNav
 * В случае добавления большего количества страниц или смежных функций, лучше отрефакторить механизм шаблонов страниц и роутинга
 * Было необходимо когда главная страница была доступна только авторизованным пользователям
 * @constructor
 */
function AppTemplateWithNavigationIfNeeded() {
  const location = useLocation();
  const navigate = useNavigate();
  const permissions = useStore($userPermissions);

  // тут указываются разделы, для которых не должно быть бокового меню навигации
  const PATH_NAMES_EXCLUDE_NAVIGATION = ['/', '/buyer-account', '/buyer-points'];
  const isNavigationNeeded = !PATH_NAMES_EXCLUDE_NAVIGATION.includes(location.pathname);
  const sections = APP_SECTIONS(permissions);
  const items = sections.map((section) => {
    return section.map((section) => ({
      ...section,
      title: section.shortTitle,
    }));
  });

  const onLogout = async () => {
    const result = await authService.logout();
    if (result.success) {
      logout();
      localStorage.clear();
      navigate('/');
    }
  };

  return (
    <AppTemplate
      // @ts-ignore
      navigation={isNavigationNeeded && <SideNav items={items} onLogout={onLogout} />}
    />
  );
}
